import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import API from "../../utils/api";

// Async Thunk for Category API Call
export const fetchSubCategories = createAsyncThunk(
  "subcategory/fetchSubCategories",
  async (categoryId, { rejectWithValue }) => {
    try {
      const response = await API.get(`/subcategories/${categoryId}`);
      return response.data.data;
    } catch (error) {
      return rejectWithValue(error.response.data.message);
    }
  }
);
export const fetchSubCategoryProducts = createAsyncThunk(
  "subcategory/fetchSubCategoryProducts",
  async ({ subCategoryId, page = 1, perPage = 10 }, { rejectWithValue }) => {
    try {
      const response = await API.get(`/subcategoryproduct/${subCategoryId}?page=${page}&perPage=${perPage}`);
      return response.data.data;
    } catch (error) {
      return rejectWithValue(error.response.data.message);
    }
  }
);

const subCategorySlice = createSlice({
  name: "subcategory",
  initialState: {
    subcategories: [],
    subcat_products: [],
    subcat_loading: false,
    subcat_error: null,
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchSubCategories.pending, (state) => {
        state.subcat_loading = true;
      })
      .addCase(fetchSubCategories.fulfilled, (state, action) => {
        state.subcat_loading = false;
        state.subcategories = action.payload;
      })
      .addCase(fetchSubCategories.rejected, (state, action) => {
        state.subcat_loading = false;
        state.subcat_error = action.payload;
      })
      .addCase(fetchSubCategoryProducts.pending, (state) => {
        state.subcat_loading = true;
      })
      .addCase(fetchSubCategoryProducts.fulfilled, (state, action) => {
        state.subcat_loading = false;
        state.subcat_products = action.payload;
      })
      .addCase(fetchSubCategoryProducts.rejected, (state, action) => {
        state.subcat_loading = false;
        state.subcat_error = action.payload;
      });
  },
});

export default subCategorySlice.reducer;
